import { useEffect, useState } from "react";

export default function HubSpotMailerForm() {
  const [formLoaded, setFormLoaded] = useState(false);

  useEffect(() => {
    const loadScript = (src, callback) => {
      const script = document.createElement("script");
      script.src = src;
      script.type = "text/javascript";
      script.charset = "utf-8";
      script.onload = callback;
      script.onerror = () => setFormLoaded(false); // If script fails, fallback
      document.body.appendChild(script);
    };

    // Load the HubSpot forms script
    loadScript("//js.hsforms.net/forms/v2.js", () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "20125216",
          formId: "3f66cac3-c8de-48c0-aa61-7747ce4faa9c",
          target: "#hubspot-mailer-form",
        });
        setFormLoaded(true); // Form loaded successfully
      }
    });

    // Set a timeout to check if the form has loaded
    const timeout = setTimeout(() => {
      setFormLoaded((prev) => prev); // If not set to true, fallback
    }, 3000); // 3 seconds should be enough for it to load

    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <h2 className="color-slate mb-4">Join the BalancedComp mailing list</h2>
      {formLoaded ? (
        <div id="hubspot-mailer-form"></div>
      ) : (
        <p>Form currently unavailable.</p>
      )}
    </>
  );
}
